import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL
const uemailURL = process.env.EMAIL_UNIVERSE_API_URL

const instance = axios.create({
    baseURL,
    timeout: 100000
});

const ueInstance = axios.create({
    uemailURL,
    timeout: 100000
});


/**
 * Extract error information from axios error info
 */
const handleError = error => {
    let errorMessage = '';
    if (error.response) {
        // Check if 'initial' field exists in the data and use it if present
        if (error.response.data.initial && error.response.data.initial.length > 0) {
            errorMessage = error.response.data.initial[0]; // taking the first message
        }
        // If not, check if 'detail' field exists and use it
        else if (error.response.data.detail) {
            errorMessage = error.response.data.detail;
        }
        throw new Error(errorMessage);
    } else {
        throw new Error(error.message)
    }
}

/**
 * Utility methods to perform HTTP methods and extract response
 */
const api = {
    get: async (url, config) => {
        try {
            const response = await instance.get(url, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    post: async (url, data = {}, config) => {
        try {
            const response = await instance.post(url, data, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    put: async (url, data = {}, config) => {
        try {
            const response = await instance.put(url, data, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    delete: async (url, data = {}, config) => {
        try {
            const response = await instance.delete(url, {
                headers: { ...config },
                withCredentials: true,
                data,
            })

            return response.data
        } catch (error) {
            handleError(error)
        }
    }
}

/**
 * Utility methods to perform HTTP methods and extract response
 */
const ueApi = {
    get: async (url, config) => {
        try {
            const response = await ueInstance.get(url, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    post: async (url, data = {}, config) => {
        try {
            const response = await ueInstance.post(url, data, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    put: async (url, data = {}, config) => {
        try {
            const response = await ueInstance.put(url, data, { ...config, withCredentials: true })

            return response.data
        } catch (error) {
            handleError(error)
        }
    },
    delete: async (url, data = {}, config) => {
        try {
            const response = await ueInstance.delete(url, {
                headers: { ...config },
                withCredentials: true,
                data,
            })

            return response.data
        } catch (error) {
            handleError(error)
        }
    }
}

export { api, ueApi }
